import Link from 'next/link';
import React from 'react';

/**
 * Footer Links Component
 * Displays service or legal links
 * 
 * @param {Array} links - Array of link objects
 * @param {String} className - Additional CSS classes
 * @param {String} linkClassName - Additional CSS classes for individual links
 */
const FooterLinks = ({ links, className = '', linkClassName = '' }) => {
    if (!links || links.filter(link => !link.isHidden).length === 0) return null;

    return (
        <ul className={`list-unstyled ${className}`}>
            {links
                ?.filter(link => !link.isHidden)
                .map((link, index) => (
                    <li key={index} className="mb-2">
                        <Link 
                            href={link.url} 
                            style={{
                                color: '#ffffff',
                                textDecoration: 'none',
                                fontSize: '14px',
                                transition: 'color 0.3s ease, padding-left 0.3s ease',
                                display: 'block',
                                paddingLeft: '0'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.color = '#f17c21';
                                e.target.style.paddingLeft = '8px';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.color = '#ffffff';
                                e.target.style.paddingLeft = '0';
                            }}
                            className={linkClassName}
                        >
                            {link.name}
                        </Link>
                    </li>
                ))}
        </ul>
    );
};

export default FooterLinks;
